import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Sidebar";

const body = ({children}) => {
  return (
    <Container className="px-5">
        <Row>
            <Col md="9">
                {children}
            </Col>
            <Col md="3">
                <Sidebar />
            </Col>
        </Row>
    </Container>
  );
};

export default body;
